const createImage = (url: string): Promise<HTMLImageElement> =>
    new Promise((resolve, reject) => {
        const image = new Image();
        image.addEventListener('load', () => resolve(image));
        image.addEventListener('error', error => reject(error));
        image.setAttribute('crossOrigin', 'anonymous'); // avoid CORS issues
        image.src = url;
    });

const getCroppedImg = async (
    imageSrc: string,
    crop: any,
    outputSize: { width: number; height: number }
): Promise<Blob> => {
    const image = await createImage(imageSrc);
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    canvas.width = outputSize.width;
    canvas.height = outputSize.height;

    if (!ctx) throw new Error('No 2d context');

    ctx.drawImage(
        image,
        crop.x,
        crop.y,
        crop.width,
        crop.height,
        0,
        0,
        outputSize.width,
        outputSize.height
    );

    return new Promise(resolve => {
        canvas.toBlob(blob => {
            if (blob) resolve(blob);
        }, 'image/png');
    });
};

export default getCroppedImg;
